import { useStore } from 'effector-react'
import { Form } from '~/entities/common/Car'
import { formSubmitted, createFx } from './model'

export function AddCar() {
  const isCreating = useStore(createFx.pending)

  return <Form isSubmitting={isCreating} isCreating onSuccess={formSubmitted} />
}
